import { styled } from '@mui/material/styles';
import MuiAppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import DesignUtils from '../../../utils/DesignUtils';
import styles from './bar.module.scss';

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: DesignUtils.getDrawerWith(),
        width: `calc(100% - ${DesignUtils.getDrawerWith()}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

export const MainAppBar = ({ open, toggleDrawer }) => {

    return (
        <AppBar className={styles.appBar} position="absolute" open={open}>
            <Toolbar sx={{ pr: '12px'}}>
                <IconButton
                    className={styles.openDrawerMenuIcon}
                    edge="start"
                    color="inherit"
                    aria-label="open drawer"
                    onClick={toggleDrawer}
                    sx={{ marginRight: '36px', marginTop: '25px', ...(open && { display: 'none' }), }}
                >
                    <MenuRoundedIcon className={styles.menu} />
                </IconButton>
                <a href="/" style={{ position: 'absolute', top: 0, right: 0, marginTop: '15px', marginRight: '25px' }}>
                    <img src="/everlink-logo.png" alt="logo" style={{ width: '200px', height: 'auto' }} />
                </a>
            </Toolbar>
        </AppBar >

    );
}